import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import AllApplications from "Main/Views/AllApplications";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// const admin = localStorage.getItem("admin_details");

// @mui icons
import Icon from "@mui/material/Icon";
import Testimonials from "Main/Views/Testimonials";

import Blogs from "Main/Views/Blogs";
import WebContacts from "Main/Views/WebContacts";
import Notifications from "Main/Views/Notifications";
import AboutUs from "Main/Views/AboutUs";
import BlogCategories from "Main/Views/BlogCategories";
import Aluminis from "Main/Views/Aluminis";
import Events from "Main/Views/Events";
import Gallery from "Main/Views/Gallery";
import Courses from "Main/Views/Courses";
import FranchiseEnquiry from "Main/Views/FarnchiseEnquiry";
import SocialMedia from "Main/Views/SocialMedia";
import SchoolEnquiry from "Main/Views/SchoolEnquiry";
import Banners from "Main/Views/Banner";
import Exams from "Main/Views/Competitive_Exams";
import CountsList from "Main/Views/AboutUsCount";
import TeamsList from "Main/Views/Teams";
import FaqList from "Main/Views/Faq";
import AmenitiesList from "Main/Views/Amenities";
import NavbarTextList from "Main/Views/NavbarSlider";
import RequestDemoList from "Main/Views/RequestDemo";
import Projects from "Main/Views/Projects";
import Products from "Main/Views/Product";
import TrustedBy from "Main/Views/TrustedBy";

let users = localStorage.getItem("admin_details");
let user;

if (users) {
  user = JSON.parse(users);
}

let routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "About Us",
    key: "career",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/aboutus",
    component: <AboutUs />,
  },
  {
    type: "collapse",
    name: "Teams",
    key: "teams",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/teams",
    component: <TeamsList />,
  },
  // {
  //   type: "collapse",
  //   name: "Banner",
  //   key: "banner",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/banner",
  //   component: <Banners />,
  // },
  {
    type: "collapse",
    name: "Project Categories",
    key: "blogcategories",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogcategories",
    component: <BlogCategories />,
  },
  {
    type: "collapse",
    name: "Projects",
    key: "projects",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/projects",
    component: <Projects />,
  },
  
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/products",
    component: <Products />,
  },

  {
    type: "collapse",
    name: "Testimonials",
    key: "testimonials",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/testimonials",
    component: <Testimonials />,
  },

   {
    type: "collapse",
    name: "Gallery",
    key: "gallery",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/gallery",
    component: <Gallery />,
  },

   {
    type: "collapse",
    name: "Trusted By",
    key: "trusted",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/trusted",
    component: <TrustedBy />,
  },
 
  
  {
    type: "collapse",
    name: "Contacts",
    key: "contacts",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/contacts",
    component: <WebContacts />,
  },

  // SUBJECT and LEVEL Routes
  // {
  //   type: "collapse",
  //   name: "Topics",
  //   key: "topics",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/topics",
  //   component: <Topics />,
  // },
  // {
  //   type: "collapse",
  //   name: "Levels",
  //   key: "levels",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/levels",
  //   component: <Levels />,
  // },
  // {
  //   type: "collapse",
  //   name: "Questions",
  //   key: "questions",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/questions",
  //   component: <Questions />,
  // },
  // {
  //   type: "collapse",
  //   name: "Test Series",
  //   key: "testseries",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/testseries",
  //   component: <TestSeries />,
  // },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "users",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/users",
  //   component: <Users />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
];

let newRoutes = [];

if (user?.employee_type === "question_creater") {
  // console.log(user);
  routes.filter((item) => {
    if (
      item.route === "/questions" ||
      item.route === "/subjects" ||
      item.route === "/levels" ||
      item.route === "/topics" ||
      item.route === "/dashboard"
    ) {
      newRoutes.push(item);
    }
  });
}
if (user?.role == "superadmin") {
  newRoutes = routes;
}
routes = newRoutes;
export default routes;
